var map = {
	"./de/pericope_titles.json": [
		45,
		45
	],
	"./el/pericope_titles.json": [
		335,
		335
	],
	"./en/pericope_titles.json": [
		569,
		569
	],
	"./es/pericope_titles.json": [
		866,
		866
	],
	"./fr/pericope_titles.json": [
		802,
		802
	],
	"./it/pericope_titles.json": [
		523,
		523
	],
	"./ru/pericope_titles.json": [
		259,
		259
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 615;
module.exports = webpackAsyncContext;